import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggingService, NotificationCenterService, PortalProductsService, SignalRHub } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { NavigationService, NavigationSettings } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss'],
})
export class MasterPageComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  screenType = ScreenType;
  navigationSettings: NavigationSettings;
  isHomePage: boolean = false;
  isTertiary: boolean = false;

  //Challenges
  isScorecardPage: boolean = false;

  //Rewards
  isPurchaseSuccessPage: boolean = false;
  isRewardsItem: boolean = false;
  isCheckOut: boolean = false;

  //Wallet Page
  isWallet: boolean = false;
  isWalletItem: boolean = false;
  isClaimedPage: boolean = false;
  isCampaignPage: boolean = false;

  title: string;
  constructor(
    private signalRHub: SignalRHub,
    private logService: LoggingService,
    private notificationCenterService: NotificationCenterService,
    private portalProductsService: PortalProductsService,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.signalRHub.connectionEstablished$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
    this.notificationCenterService.fetchNotificationCenter(5).pipe(takeUntilDestroyed(this._destroyRef)).subscribe();
    this.portalProductsService.fetchPortalProducts().pipe(takeUntilDestroyed(this._destroyRef)).subscribe();

    // Subscribe to navigation changes
    this.navigationService.onNavigationChanged.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((navigationSettings) => {
      this.navigationSettings = navigationSettings;
    });

    this.router.events.subscribe(() => {
      const fullPath = this.getFullRoutePath(this.route);
      this.isWallet = false;
      this.isHomePage = false;
      this.isTertiary = false;
      this.isWalletItem = false;
      this.isClaimedPage = false;
      this.isCampaignPage = false;
      this.isPurchaseSuccessPage = false;
      this.isRewardsItem = false;
      this.isScorecardPage = false;
      this.isCheckOut = false;

      //check routing to display mobile nav
      if (fullPath?.length == 0) {
        this.isHomePage = true;
      } else if (fullPath.includes('/checkout')) {
        this.isCheckOut = true;
        this.title = 'checkout';
        this.isWallet = true;
      } else if (fullPath.includes('/rewards')) {
        //Wallet page
        if (fullPath.includes('wallet')) {
          this.isWallet = true;
          this.title = 'Wallet';
        }
        //Rewards page
        else {
          this.title = 'redeem';
        }

        // Rewards details page
        if (
          fullPath.includes('marketplace/details') ||
          fullPath.includes('auctions/details') ||
          fullPath.includes('raffles/details')
        ) {
          this.isRewardsItem = true;
        }

        //Wallet items page
        if (fullPath.includes('wallet/')) {
          this.isWalletItem = true;
        }

        //Claimed Rewards Page
        if (fullPath.includes('claimed')) {
          this.isWallet = true;
          this.title = 'Claimed Rewards';
          this.isClaimedPage = true;
        }

        //Campaign page
        if (fullPath.includes('campaign/details') || fullPath.includes('bids/details')) {
          this.title = 'Wallet';
          this.isWallet = true;
          this.isCampaignPage = true;
        }
      } else if (
        fullPath.includes('contact') ||
        fullPath.includes('terms') ||
        fullPath.includes('faq') ||
        fullPath.includes('worksheet') ||
        fullPath.includes('earn')
      ) {
        this.isTertiary = true;
        //Tertiary Pages
        if (fullPath.includes('contact')) {
          this.title = 'Contact Us';
        } else if (fullPath.includes('terms')) {
          this.title = 'Terms & Conditions';
        } else if (fullPath.includes('faq')) {
          this.title = 'FAQs';
        } else if (fullPath.includes('worksheet')) {
          this.title = 'Gallery';
        } else if (fullPath.includes('earn')) {
          this.title = 'Earn Points';
        }
      } else {
        if (fullPath.includes('challenges')) {
          this.title = 'Challenges';
        } else if (fullPath.includes('activity') || fullPath.includes('account')) {
          this.title = 'Profile';
        } else if (fullPath.includes('ecash')) {
          this.title = 'Jets Cash';
        }

        if (fullPath.includes('/scorecard-description')) {
          this.isScorecardPage = true;
        }

        if (fullPath.includes('/purchase/success')) {
          this.isRewardsItem = false;
          this.isPurchaseSuccessPage = true;
          this.title = 'Redeem';
        }
      }
    });
  }

  private getFullRoutePath(route: ActivatedRoute): string {
    let path = '';
    while (route) {
      if (route.snapshot.url.length) {
        path += '/' + route.snapshot.url.map((segment) => segment.path).join('/');
      }
      route = route.firstChild!;
    }
    return path;
  }
}
